













import { Component, Vue } from "vue-property-decorator"
import { initialState } from "../store/initial"
import { rounds } from "../game_content/rounds"
@Component
export default class PauseMenu extends Vue {
  protected resume() {
    if (!this.$store.state.tutorial) { this.$store.dispatch("unpause") }
  }

  protected tutorial() {
    if (!this.$store.state.tutorial) { this.$store.dispatch("beginTutorial") }
  }

  protected restart() {
    if (!this.$store.state.tutorial) {
      const newState = initialState()
      newState.muted = this.$store.state.muted
      // newState.firstLoad = this.$store.state.firstLoad
      this.$store.replaceState(newState)
      this.$store.commit("RETRIEVE_MARKDOWN", rounds())
    }
  }
  protected instructions() {
    if (!this.$store.state.tutorial) {
      if (!this.$store.state.muted) {
        new Howl({
          src: ["/audio/Click.mp3"]
        }).play()
      }
      this.$store.dispatch("instructionsRedo")
    }
  }
}
